function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.539062 12C0.539062 5.37258 5.91165 0 12.5391 0C19.1665 0 24.5391 5.37258 24.5391 12C24.5391 18.6274 19.1665 24 12.5391 24C5.91165 24 0.539062 18.6274 0.539062 12Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9132 3C16.0741 4.09331 15.6291 5.16439 15.0421 5.92219C14.414 6.73502 13.3315 7.3637 12.2826 7.33089C12.0911 6.28415 12.5814 5.20566 13.1779 4.48067C13.8322 3.68054 14.9537 3.06668 15.9132 3ZM19.0641 18.3888C19.6048 17.5601 19.8068 17.1421 20.2266 16.2065C17.1735 15.0454 16.6843 10.705 19.7058 9.03911C18.7842 7.88336 17.4891 7.21341 16.2667 7.21341C15.3858 7.21341 14.7823 7.44327 14.2336 7.65224C13.7764 7.82639 13.3573 7.98602 12.8475 7.98602C12.2967 7.98602 11.8088 7.81111 11.298 7.62797C10.7367 7.42672 10.1477 7.21552 9.41681 7.21552C8.04494 7.21552 6.5847 8.05376 5.65891 9.48681C4.35753 11.5051 4.57951 15.2994 6.68991 18.5317C7.44422 19.6885 8.45208 20.9882 9.77029 20.9999C10.3173 21.0053 10.6812 20.842 11.0751 20.6654C11.526 20.4632 12.016 20.2434 12.8644 20.2389C13.7178 20.2338 14.2 20.4562 14.6449 20.6614C15.0286 20.8384 15.3845 21.0026 15.9269 20.9967C17.2461 20.9861 18.3097 19.5456 19.0641 18.3888Z",
  fill: "#0B0B0A"
});

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.92f89d00.svg";
export { ForwardRef as ReactComponent };